import { createContext } from "react"

interface TabsContextType {
  activeTab: string
  setActiveTab: any
}
const defaultValue = { activeTab: "", setActiveTab: () => {} }
export const TabsContext = createContext<TabsContextType>(defaultValue)
